<div class="modal-content" style="background-color: transparent !important;">
	<div class="modal-header py-2" style="background: #06345B;color: #fff;">
		<h4 class="modal-title w-100 text-left gameplan_header" id="myModalLabel">Exam Game Plan</h4>
		<button type="button" class="close pull-right" aria-label="Close" (click)="closeModel()">
			<img src="assets/contact_images/cross_circle_white.svg" alt=""></button>
	</div>
	<div class="modal-body bg-white">
		<div class="container-fluid pb-2 px-1">
			<div class="game-modal-exam">
				<div class="game-modal-intro">
					<p class="mb-2">
						<span style="font-family: var(--open_sans_semiBold);
                      font-size: 18px;
                      line-height: 31.2px;
                      color: #0D0D12;">Hi&nbsp;{{studentDetails.stud_name}}</span>,<br>We want to know your tentative
						plan for the CPA exams so we can set up your LMS.
					</p>
				</div>
				<hr style="border: 0.2px solid #c6c2c2;">
				<div *ngIf="!studentEnrolledHide && isBecSelected == 0">
					<div class="bec-choose" *ngIf="!editStatus">
						<p>Have you appeared and passed Business Environment and Concepts (BEC) ?</p>
						<small>Choose Yes only if you have passed BEC or appeared for BEC and awaiting results.</small>
						<div class="bec-choose-option">
							<div *ngIf="chooseActive == 0" class="form-check">
								<input class="form-check-input" type="radio" name="bec" id="YES" value="YES"
									(change)="toggleInput(1, $event)" mdbInput="mdbInput">
								<label class="form-check-label" for="YES">
									YES
								</label>
							</div>
							<div *ngIf="chooseActive == 1" class="form-check">
								<input class="form-check-input" type="radio" name="bec" id="YES" value="YES"
									checked="checked" (change)="toggleInput(1, $event)" mdbInput="mdbInput">
								<label class="form-check-label" for="YES">
									YES
								</label>
							</div>
							<div *ngIf="chooseActive == 1" class="form-check">
								<input class="form-check-input" type="radio" name="bec" id="NO" value="NO"
									(change)="toggleInput(2, $event)" mdbInput="mdbInput">
								<label class="form-check-label" for="NO">
									NO
								</label>
							</div>
							<div *ngIf="chooseActive == 0" class="form-check">
								<input class="form-check-input" type="radio" name="bec" id="NO" value="NO"
									(change)="toggleInput(2, $event)" mdbInput="mdbInput">
								<label class="form-check-label" for="NO">
									NO
								</label>
							</div>
							<div *ngIf="chooseActive == 2" class="form-check">
								<input class="form-check-input" type="radio" name="bec" id="YES" value="YES"
									(change)="toggleInput(1, $event)" mdbInput="mdbInput">
								<label class="form-check-label" for="YES">
									YES
								</label>
							</div>
							<div *ngIf="chooseActive == 2" class="form-check">
								<input class="form-check-input" type="radio" name="bec" id="NO" value="NO"
									checked="checked" (change)="toggleInput(2, $event)" mdbInput="mdbInput">
								<label class="form-check-label" for="NO">
									NO
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="loader" *ngIf="isSpinner"></div>
				<div class="row" [ngClass]="isMobile?'mx-0':''" *ngIf="chooseActive != 0 && !isSpinner">
					<div class="col-12 mx-auto" [ngClass]="isMobile?'px-0':''">
						<p class="mt-3 status-game-modal">Your Current Game Plan Status :
						</p>
						<div class=" d-flex align-content-around align-items-center game-modal-status pb-2">
							<!-- <label class="control-label"><b>Your Current Gameplan Status : </b></label>
                                                                -->
							<label *ngIf="evalDataStatus"
								class="control-label my-auto form-control">{{evalDataStatus}}</label>
							<!-- <input type="text" disabled class="form-contol w-100 text-center"
                                                                [(ngModel)]="evalDataStatus"> -->

							<!-- <ng-select class="w-100 mx-auto"
                                                                [ngClass]="!isMobile?'custom':'custom-mobile'" [items]="evalOption"
                                                                name="evalData" bindLabel="option" [(ngModel)]="evalDataId"
                                                                bindValue="gameplan_evaluation_confirmation_id" placeholder="Choose option"
                                                                required [readonly]="!editStatus" disabled> </ng-select> -->
							<ng-container *ngIf="evalDataStatus && (studentGPLevel.length > 0 || !studentEnrolledHide)">
								<button *ngIf="!editStatus && evalDataVal" mdbBtn="mdbBtn" type="button" color="primary"
									size="sm" class="my-auto game-medit"
									(click)="editStatus = true;subjectStatus = false"
									style="background: #0348AA !important; text-transform: none;">Edit</button>

								<button *ngIf="editStatus && evalDataVal" mdbBtn="mdbBtn" type="button" color="primary"
									size="sm" class="my-auto game-medit"
									(click)="editStatus = false;subjectStatus = true"
									style="background: #0348AA !important; text-transform: none;">Back</button>
							</ng-container>
						</div>

						<div *ngIf="editStatus || !!!evalDataStatus">
							<!-- <app-eva-confirmation></app-eva-confirmation> -->
							<div class="row mx-0" *ngIf="studentGPLevel.length > 0 || !studentEnrolledHide">
								<div class="col-12 px-0">
									<ng-container *ngIf="studentGPLevel.length > 0 && studentEnrolledHide">
										<div *ngFor="let eval of studentGPLevel">
											<ng-container *ngIf="eval.gameplan_evaluation_confirmation_id !=13">
												<div *ngIf="evalData?.studyplanner_status != null"
													class="form-check py-1 px-0">
													<input *ngIf="eval.option == evalData?.studyplanner_status" type="radio"
														class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														checked="checked" (change)="onChange($event)" mdbInput="mdbInput">
													<input *ngIf="eval.option != evalData?.studyplanner_status" type="radio"
														class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														(change)="onChange($event)" mdbInput="mdbInput">
													<label class="form-check-label"
														for="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														style="font-size:14px">{{eval.option}}</label>
												</div>
												<div *ngIf="evalData?.studyplanner_status == null"
													class="form-check py-1 px-0">
													<input *ngIf="eval.option == evalData?.gameplan_current_status"
														type="radio" class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														checked="checked" (change)="onChange($event)" mdbInput="mdbInput">
													<input *ngIf="eval.option != evalData?.gameplan_current_status"
														type="radio" class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														(change)="onChange($event)" mdbInput="mdbInput">
													<label class="form-check-label"
														for="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														style="font-size:14px">{{eval.option}}</label>
												</div>
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="!studentEnrolledHide">
										<div *ngFor="let eval of evalOption">
											<ng-container *ngIf="eval.gameplan_evaluation_confirmation_id !=13">
												<div *ngIf="evalData?.studyplanner_status != null"
													class="form-check py-1 px-0">
													<input *ngIf="eval.option == evalData?.studyplanner_status" type="radio"
														class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														checked="checked" (change)="onChange($event)" mdbInput="mdbInput">
													<input *ngIf="eval.option != evalData?.studyplanner_status" type="radio"
														class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														(change)="onChange($event)" mdbInput="mdbInput">
													<label class="form-check-label"
														for="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														style="font-size:14px">{{eval.option}}</label>
												</div>
												<div *ngIf="evalData?.studyplanner_status == null"
													class="form-check py-1 px-0">
													<input *ngIf="eval.option == evalData?.gameplan_current_status"
														type="radio" class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														checked="checked" (change)="onChange($event)" mdbInput="mdbInput">
													<input *ngIf="eval.option != evalData?.gameplan_current_status"
														type="radio" class="form-check-input"
														id="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														name="evalOption"
														value="{{eval.gameplan_evaluation_confirmation_id}}"
														(change)="onChange($event)" mdbInput="mdbInput">
													<label class="form-check-label"
														for="evalOption_{{eval.gameplan_evaluation_confirmation_id}}"
														style="font-size:14px">{{eval.option}}</label>
												</div>
											</ng-container>
										</div>
									</ng-container>
									
									<!-- Do it on monday *ngIf="eval.option == evalData?.gameplan_current_status &&
                                                                                        eval.previous_gameplan_status == undefined" -->
								</div>
								<button type="button" mdbBtn="mdbBtn" color="primary" [disabled]="evalnts_status == 0"
									style="background: #06345B;" class="relative waves-light btn btn-md"
									mdbWavesEffect="mdbWavesEffect"
									(click)="editStatus = false;subjectStatus = true;">Proceed</button>

							</div>
						</div>

					</div>

				</div>

				<div *ngIf="!editStatus && !isSpinner">
					<div *ngIf="chooseActive == 1">
						<ng-container *ngIf="subjectStatus">
							<div class="row" [ngClass]="isMobile?'mx-0':''">
								<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
									<div class="mt-4 d-flex align-content-around align-items-center">
										<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-aud">
											<form name="audForm" #audForm="ngForm" class="mx-auto w-100">
												<div
													style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
													Auditing &amp; Attestation</div>
												<div style="margin: 5px;" class="md-form">
													<ng-select class="mb-3 w-100 mx-auto"
														[ngClass]="!isMobile?'custom':'custom-mobile'"
														[items]="statusList" name="audstatusList"
														bindLabel="exam_status_type" [(ngModel)]="audData.exam_status"
														bindValue="exam_status_id" placeholder="Choose option"
														(change)="audChange()" required="required"></ng-select>
												</div>

												<div class="d-flex flex-fill">
													<div class="col mx-1 px-0" *ngIf="audData.exam_status !== 2 || audData.exam_status !== 5">
														<div class="mt-1 mb-2" *ngIf="audData.exam_status===1 || audData.exam_status===9">
															<label for="plannercalender" class="cotrol-label mb-0 plannedMonth">Planned Month</label>
															<!-- [ngClass]="audData.date_of_exam?'plannedMonth':'plannedMonth'" -->
															<div class="gamePlan-Subject-input">
																<!-- md-form md-outline  -->
																<input type="text" id="plannercalender"
																	class="bg-white form-control plannedMonthInput"
																	name="date" [(ngModel)]="audData.date_of_exam"
																	(focus)="monthModal.show();switchId=1"
																	required="required" mdbInput="mdbInput"
																	placeholder="Planned Month"
																	mdbValidate="mdbValidate">
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="audData.exam_status===3 || audData.exam_status===6">
															<label class="plannedMonth control-label mb-0">Scheduled Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="form2"
																	name="mydate" [options]="myDatePickerOptions"
																	class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="audData.exam_status===4 ? 'custom-width':''"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="audData.date_of_exam"
																	[placeholder]="'Scheduled date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="audData.exam_status===4 || audData.exam_status===7">
															<label class="plannedMonth control-label mb-0">Exam Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="passform2"
																name="mypassdate" [options]="passedDateOption"
																class="custom-date-picker-input plannedMonthInput"
																[ngClass]="audData.exam_status===4 ? 'custom-width':''"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="audData.date_of_exam"
																[placeholder]="'Exam date'"
																required="required"></mdb-date-picker>
															</div>
															
														</div>
													</div>
													<div class="row"
														*ngIf="audData.exam_status === 2 || audData.exam_status === 5">
														<div class="col-md-6">
															<div class="mt-0 mb-2">
																<label for="barplannercalender" class="plannedMonth control-label mb-0">Planned Month</label>
																<div class="gamePlan-Subject-input">
																	<input type="text" id="barplannercalender"
																	class="bg-white form-control plannedMonthInput" name="bardate"
																	[(ngModel)]="audData.date_of_exam"
																	(focus)="monthModal.show();switchId=1"
																	required="required" mdbInput="mdbInput" placeholder="Planned Month"
																	mdbValidate="mdbValidate">
																</div>
																
															</div>
														</div>
														<div class="col-md-6" *ngIf="audData.exam_status === 2">
															<div class="mt-0 mb-2">
															<label class="plannedMonth control-label mb-0" *ngIf="audData.expiry_date">NTS Expiry Date</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate" mdbLabel="mdbLabel" class="form-label">NTS Expiry Date</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate"
																	class="custom-date-picker-input plannedMonthInput"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="audData.expiry_date"
																	[disabled]="disableExpiry.audExpiryDisabled"
																	data-mdb-inline="true" [placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
															</div>
														</div>
														<div class="col-md-6" *ngIf="audData.exam_status === 5">
															<div class="mt-0 mb-2">
															<label class="plannedMonth control-label mb-0">Reschedule NTS Expiry</label> 
															<!-- *ngIf="audData.reappear_expiry_date" -->
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="audData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="audData.reappear_expiry_date"
																	[disabled]="disableExpiry.reappearAudExpiryDisabled"
																	[placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
														</div>
													</div>
													<ng-container *ngIf="audData.exam_status===4">
														<div class="col mx-1 px-0">
															<div class="mt-0 mb-2">
																<label for="audscore" class="plannedMonth control-label mb-0">Score</label>
															<div class="gamePlan-Subject-input"
																[ngClass]="audData.exam_status===4 ? 'custom-width-score':''">
																<ng-select [items]="scoreArray" name="audscore" id="audscore" class="plannedMonthInput"
																	[(ngModel)]="audData.score"
																	placeholder="Choose score"
																	required="required"></ng-select>
															</div>
														</div>
														</div>
													</ng-container>

												</div>
											</form>
										</div>
									</div>

								</div>
								<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
									<div class="mt-4 d-flex align-content-around align-items-center">
										<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-bec">
											<form name="becForm" #becForm="ngForm" class="mx-auto w-100">
												<div
													style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
													Business Environment &amp; Concepts</div>
												<div style="margin: 5px;" class="md-form">
													<ng-select class="mb-3 w-100 mx-auto"
														[ngClass]="!isMobile?'custom':'custom-mobile'"
														[items]="becstatusList" name="becstatusList"
														bindLabel="exam_status_type" [(ngModel)]="becData.exam_status"
														bindValue="exam_status_id" placeholder="Choose option"
														required="required" (change)="becChange()"></ng-select>
												</div>

												<div class="d-flex flex-fill">
													<div class="col mx-1 px-0"
														*ngIf="becData.exam_status !== 2 || becData.exam_status !== 5">
														<div class="mt-0 mb-2"
															*ngIf="becData.exam_status===1 || becData.exam_status===9">
															<label for="becplannercalender"
																class="control-label plannedMonth mb-0">Planned
																Month</label>
															<div class="gamePlan-Subject-input">
																<input type="text" id="becplannercalender"
																	class="bg-white form-control plannedMonthInput"
																	name="becdate" [(ngModel)]="becData.date_of_exam"
																	(focus)="monthModal.show();switchId=2"
																	required="required" mdbInput="mdbInput"
																	mdbValidate="mdbValidate">
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="becData.exam_status===3 || becData.exam_status===6">
															<label class="plannedMonth control-label mb-0">Scheduled Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="becform2"
																name="becmydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="becData.exam_status===4 ? 'custom-width':''"
																[options]="myDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="becData.date_of_exam"
																[placeholder]="'Scheduled date'"
																required="required"></mdb-date-picker>
															</div>
																<!-- md-form md-outline  -->
															
														</div>
														<div class="mt-0 mb-2" *ngIf=" becData.exam_status===4  || becData.exam_status===7">
															<label class="plannedMonth control-label mb-0">Exam Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="bec2form2"
																name="bec2mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="becData.exam_status===4 ? 'custom-width':''"
																[options]="becPassedOption" mdbValidate="mdbValidate"
																mdbInput="mdbInput" [(ngModel)]="becData.date_of_exam"
																[placeholder]="'Exam date'"
																required="required"></mdb-date-picker>
															</div>
															
														</div>
													</div>
													<div class="row" *ngIf="becData.exam_status === 2 || becData.exam_status === 5">
														<div class="col-md-6">
															<div class="mt-0 mb-2">
																<label for="barplannercalender" class="plannedMonth control-label mb-0">Planned Month</label>
																<div class="gamePlan-Subject-input">
																	<input type="text" id="barplannercalender"
																		class="bg-white form-control plannedMonthInput" name="bardate"
																		[(ngModel)]="becData.date_of_exam"
																		(focus)="monthModal.show();switchId=2"
																		required="required" mdbInput="mdbInput"
																		mdbValidate="mdbValidate">
																	<!-- <label for="barplannercalender" [ngClass]="becData.date_of_exam?'plannedMonth':''">Planned Month</label> -->
																</div>
															</div>
														</div>

														<div class="col-md-6" *ngIf="becData.exam_status === 2">
															<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">NTS Expiry Date</label>
															<!-- dateLabel  -->
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate" mdbLabel="mdbLabel"
																	class="form-label">NTS Expiry Date</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="becData.expiry_date"
																	[disabled]="disableExpiry.becExpiryDisabled"
																	data-mdb-inline="true" [placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
															</div>
														</div>
														<div class="col-md-6" *ngIf="becData.exam_status === 5">
															<div class="mt-0 mb-2">
																<!-- <label for="ntExpiryDate" mdbLabel="mdbLabel"
																	class="form-label">NTS Expiry Date</label> -->
																<label class="plannedMonth mb-0 control-label">Reschedule NTS Expiry</label>
																<!-- [ngClass]="becData.reappear_expiry_date?'plannedMonth':''"
																*ngIf="becData.reappear_expiry_date">Reschedule NTS
																Expiry -->
																<!-- dateLabel -->
																<div class="gamePlan-Subject-input ntsExpiryDate">
																	<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																	<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="becData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="becData.reappear_expiry_date"
																	[disabled]="disableExpiry.reappearBecExpiryDisabled"
																	[placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
																</div>	
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="becData.exam_status===4">
														<div class="mb-0 mb-2">
															<label for="becscore" class="plannedMonth control-label mb-0">Score</label>
															<div class="gamePlan-Subject-input" [ngClass]="becData.exam_status===4 ? 'custom-width-score':''">
																<ng-select [items]="scoreArray" name="becscore" class="plannedMonthInput"
																	[(ngModel)]="becData.score" placeholder="Choose score"
																	required="required"></ng-select>
															</div>
														</div>
													</div>
												</div>
											</form>
										</div>
									</div>

								</div>

							</div>

							<div class="row" [ngClass]="isMobile?'mx-0':''">
								<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
									<div class="mt-4 d-flex align-content-around align-items-center">
										<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-far">
											<form name="farForm" #farForm="ngForm" class="mx-auto w-100">
												<div
													style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
													Financial Accounting &amp; Reporting</div>
												<div style="margin: 5px;" class="md-form">
													<ng-select class="mb-3 w-100 mx-auto"
														[ngClass]="!isMobile?'custom':'custom-mobile'"
														[items]="statusList" name="farstatusList"
														bindLabel="exam_status_type" [(ngModel)]="farData.exam_status"
														bindValue="exam_status_id" placeholder="Choose option"
														required="required" (change)="farChange()"></ng-select>
												</div>

												<div class="d-flex flex-fill">
													<div class="col mx-1 px-0"
														*ngIf="farData.exam_status !== 2 || farData.exam_status !== 5">
														<div class="mt-0 mb-2"
															*ngIf="farData.exam_status===1 || farData.exam_status===9">
															<label for="farplannercalender"
																class="control-label plannedMonth mb-0">Planned
																Month</label>
															<div class="gamePlan-Subject-input">
																<input type="text" id="farplannercalender"
																	class="bg-white form-control plannedMonthInput"
																	name="fardate" [(ngModel)]="farData.date_of_exam"
																	(focus)="monthModal.show();switchId=3"
																	required="required" mdbInput="mdbInput"
																	mdbValidate="mdbValidate">
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="farData.exam_status===3 || farData.exam_status===6">
															<label class="plannedMonth control-label mb-0">Scheduled Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="farform2"
																name="farmydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="farData.exam_status===4 ? 'custom-width':''"
																[options]="myDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="farData.date_of_exam"
																[placeholder]="'Scheduled date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="farData.exam_status===4 || farData.exam_status===7">
															<label class="plannedMonth control-label mb-0">Exam Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="far2form2"
																	name="far2mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="farData.exam_status===4 ? 'custom-width':''"
																	[options]="passedDateOption" mdbValidate="mdbValidate"
																	mdbInput="mdbInput" [(ngModel)]="farData.date_of_exam"
																	[placeholder]="'Exam date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
													<div class="row"
														*ngIf="farData.exam_status === 2 || farData.exam_status === 5">
														<div class="col-md-6">
															<div class="mt-0 mb-2">
																<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
																<div class="gamePlan-Subject-input">
																	<input type="text" id="barplannercalender"
																			class="bg-white form-control plannedMonthInput" name="bardate"
																			[(ngModel)]="farData.date_of_exam"
																			(focus)="monthModal.show();switchId=3"
																			required="required" mdbInput="mdbInput"
																			mdbValidate="mdbValidate">
																</div>
															</div>
														</div>
														<div class="col-md-6" *ngIf="farData.exam_status === 2">
															<div class="mt-0 mb-2">
																<label class="plannedMonth control-label mb-0">NTS Expiry Date</label>
																<div class="gamePlan-Subject-input ntsExpiryDate">
																	<!-- <label for="ntExpiryDate" mdbLabel="mdbLabel"
																		class="form-label">NTS Expiry Date</label> -->
																	<mdb-date-picker [outlineInput]="true" id="bar3form3"
																		name="bar3mydate" class="custom-date-picker-input"
																		[options]="newDatePickerOptions"
																		mdbValidate="mdbValidate" mdbInput="mdbInput"
																		[(ngModel)]="farData.expiry_date"
																		[disabled]="disableExpiry.farExpiryDisabled"
																		data-mdb-inline="true" [placeholder]="'Expiry Date'"
																		required="required"></mdb-date-picker>
																</div>
															</div>
														</div>
														<div class="col-md-6" *ngIf="farData.exam_status === 5">
															<div class="mt-0 mb-2">
																<label class="plannedMonth control-label mb-0">Reschedule NTS Expiry</label>
																<div class="gamePlan-Subject-input ntsExpiryDate">
																	<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																	<mdb-date-picker [outlineInput]="true" id="bar3form3"
																		name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																		[ngClass]="farData.exam_status === 2 ? 'custom-width':''"
																		[options]="newDatePickerOptions"
																		mdbValidate="mdbValidate" mdbInput="mdbInput"
																		[(ngModel)]="farData.reappear_expiry_date"
																		[disabled]="disableExpiry.reappearFarExpiryDisabled"
																		[placeholder]="'Expiry Date'"
																		required="required"></mdb-date-picker>
																</div>
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="farData.exam_status===4">
														<div class="mt-0 mb-2">
															<label for="farScore" class="plannedMonth control-label mb-0">Score</label>
															<!-- [ngClass]="farData.score?'plannedMonth':''" -->
															<div class="gamePlan-Subject-input"
																[ngClass]="farData.exam_status===4 ? 'custom-width-score':''">
																<ng-select [items]="scoreArray" name="farscore"
																	[(ngModel)]="farData.score" placeholder="Choose score" class="plannedMonthInput"
																	required="required"></ng-select>
															</div>
														</div>
													</div>
												</div>
											</form>
										</div>
									</div>

								</div>
								<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
									<div class="mt-4 d-flex align-content-around align-items-center">
										<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-reg">
											<form name="regForm" #regForm="ngForm" class="mx-auto w-100">
												<div
													style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
													Taxation & Regulation</div>
												<div style="margin: 5px;" class="md-form">
													<ng-select class="mb-3 w-100 mx-auto"
														[ngClass]="!isMobile?'custom':'custom-mobile'"
														[items]="statusList" name="regstatusList"
														bindLabel="exam_status_type" [(ngModel)]="regData.exam_status"
														bindValue="exam_status_id" placeholder="Choose option"
														required="required" (change)="regChange()"></ng-select>
												</div>

												<div class="d-flex flex-fill">
													<div class="col mx-1 px-0"
														*ngIf="regData.exam_status !== 2 || regData.exam_status !== 5">
														<div class="mt-0 mb-2"
															*ngIf="regData.exam_status===1 ||  regData.exam_status===9">
															<label for="regplannercalender"
																class="control-label plannedMonth mb-0">Planned
																Month</label>
															<div class="gamePlan-Subject-input">
																<input type="text" id="regplannercalender"
																	class="bg-white form-control plannedMonthInput"
																	name="regdate" [(ngModel)]="regData.date_of_exam"
																	(focus)="monthModal.show();switchId=4"
																	required="required" mdbInput="mdbInput"
																	mdbValidate="mdbValidate">
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="regData.exam_status===3 || regData.exam_status===6">
															<label class="control-label plannedMonth mb-0">Scheduled Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="regform2"
																name="regmydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="regData.exam_status===4 ? 'custom-width':''"
																[options]="myDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="regData.date_of_exam"
																[placeholder]="'Scheduled date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
														<div class="mt-0 mb-2" *ngIf="regData.exam_status===4 || regData.exam_status===7">
															<label class="control-label plannedMonth mb-0">Exam Date</label>
															<div class="gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="reg2form2"
																name="reg2mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="regData.exam_status===4 ? 'custom-width':''"
																[options]="passedDateOption" mdbValidate="mdbValidate"
																mdbInput="mdbInput" [(ngModel)]="regData.date_of_exam"
																[placeholder]="'Exam date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
													<div class="row"
														*ngIf="regData.exam_status === 2 || regData.exam_status === 5">
														<div class="col-md-6">
															<div class="mt-0 mb-2">
																<label for="barplannercalender" class="plannedMonth control-label mb-0">Planned Month</label>
																<div class="gamePlan-Subject-input">
																	<input type="text" id="barplannercalender"
																		class="bg-white form-control plannedMonthInput" name="bardate"
																		[(ngModel)]="regData.date_of_exam"
																		(focus)="monthModal.show();switchId=4"
																		required="required" mdbInput="mdbInput"
																		mdbValidate="mdbValidate">
																</div>
															</div>
														</div>
														<div class="col-md-6" *ngIf="regData.exam_status === 2">
															<div class="mt-0 mb-2">
																<label class="plannedMonth mb-0 control-label">NTS Expiry Date</label>
																<div class="gamePlan-Subject-input ntsExpiryDate">
																	<!-- <label for="ntExpiryDate" mdbLabel="mdbLabel"
																		class="form-label">NTS Expiry Date</label> -->
																	<mdb-date-picker [outlineInput]="true" id="bar3form3"
																		name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																		[options]="newDatePickerOptions"
																		mdbValidate="mdbValidate" mdbInput="mdbInput"
																		[(ngModel)]="regData.expiry_date"
																		[disabled]="disableExpiry.regExpiryDisabled"
																		data-mdb-inline="true" [placeholder]="'Expiry Date'"
																		required="required"></mdb-date-picker>
																</div>
															</div>
														</div>
														<div class="col-md-6" *ngIf="regData.exam_status === 5">
															<div class="mt-0 mb-2">
																<label class="plannedMonth control-label mb-0">Reschedule NTS Expiry</label>
																<div class="gamePlan-Subject-input ntsExpiryDate">
																	<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																	<mdb-date-picker [outlineInput]="true" id="bar3form3"
																		name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																		[ngClass]="regData.exam_status === 2 ? 'custom-width':''"
																		[options]="newDatePickerOptions"
																		mdbValidate="mdbValidate" mdbInput="mdbInput"
																		[(ngModel)]="regData.reappear_expiry_date"
																		[disabled]="disableExpiry.reappearRegExpiryDisabled"
																		[placeholder]="'Reschedule Expiry Date'"
																		required="required"></mdb-date-picker>
																</div>
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="regData.exam_status===4">
														<div class="mt-0 mb-2">
															<label for="regscore" class="plannedMonth control-label mb-0">Score</label>
															<div class="gamePlan-Subject-input" [ngClass]="regData.exam_status===4 ? 'custom-width-score':''">
																<ng-select [items]="scoreArray" name="regscore"
																[(ngModel)]="regData.score" placeholder="Choose score"
																required="required"></ng-select>
															</div>
														</div>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>

						</ng-container>
					</div>

					<div *ngIf="chooseActive == 2" class="game-modal-accordions">

						<div class="row" [ngClass]="isMobile?'mx-0':''">
							<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
								<div class="mt-4 d-flex align-content-around align-items-center">
									<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-aud">
										<form name="audForm" #audForm="ngForm" class="mx-auto w-100">
											<div class="game-sub-title"
												style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
												Auditing &amp; Attestation</div>
											<div style="margin: 5px;" class="md-form">
												<ng-select class="mb-3 w-100 mx-auto"
													[ngClass]="!isMobile?'custom':'custom-mobile'" [items]="statusList"
													name="audstatusList" bindLabel="exam_status_type"
													[(ngModel)]="audData.exam_status" bindValue="exam_status_id"
													placeholder="Choose option" (change)="audChange()"
													required="required"></ng-select>
											</div>

											<div class="mx-0 d-flex flex-fill">
												<div class="col mx-1 px-0" *ngIf="audData.exam_status !==2 && audData.exam_status !== 5">
													<div class="mt-0 mb-2" *ngIf="audData.exam_status===1 || audData.exam_status=== 9">
														
														<label for="plannercalender"
															class="plannedMonth control-label mb-0">Planned
															Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="plannercalender"
																class="bg-white form-control plannedMonthInput"
																name="date" [(ngModel)]="audData.date_of_exam"
																(focus)="monthModal.show();switchId=1"
																required="required" mdbInput="mdbInput"
																placeholder="Choose month"
																mdbValidate="mdbValidate">
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="audData.exam_status===3 || audData.exam_status===6">
														<label class="plannedMonth control-label mb-0">Scheduled Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="form2" name="mydate"
																[options]="myDatePickerOptions"
																class="custom-date-picker-input plannedMonthInput"
																[ngClass]="audData.exam_status===4 ? 'custom-width':''"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="audData.date_of_exam"
																[placeholder]="'Scheduled date'"
																required="required"></mdb-date-picker>
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="audData.exam_status===4 || audData.exam_status===7">
														<label class="plannedMonth control-label mb-0">Exam Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="passform2"
																name="mypassdate" [options]="passedDateOption"
																class="custom-date-picker-input plannedMonthInput"
																[ngClass]="audData.exam_status===4 ? 'custom-width':''"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="audData.date_of_exam"
																[placeholder]="'Exam date'"
																required="required"></mdb-date-picker>
														</div>
													</div>
												</div>

												<ng-container *ngIf="audData.exam_status === 2 || audData.exam_status === 5">
													<div class="col mx-1 px-0">
														<div class="mt-0 mb-2">
															<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
															<div class="gamePlan-Subject-input">
																<input type="text" id="barplannercalender"
																	class="bg-white form-control plannedMonthInput" name="bardate"
																	[(ngModel)]="audData.date_of_exam"
																	(focus)="monthModal.show();switchId=1"
																	required="required" mdbInput="mdbInput"
																	placeholder="Choose month"
																	mdbValidate="mdbValidate">
															</div>
														</div>
													</div>

													<div class="col mx-1 px-0" *ngIf="audData.exam_status === 2">
														<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">NTS Expiry Date</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="audData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="audData.expiry_date"
																	[disabled]="disableExpiry.audExpiryDisabled"
																	data-mdb-inline="true" [placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
													<!-- *ngIf="audData.exam_status === 5" -->
													<div class="col mx-1 px-0" *ngIf="audData.exam_status === 5">
														<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">Reschedule NTS Expiry</label>
															<!-- [ngClass]="audData.expiry_date?'plannedMonth':''"
															*ngIf="audData.reappear_expiry_date">Reschedule NTS
															Expiry</label> -->
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="audData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="audData.reappear_expiry_date"
																	[disabled]="disableExpiry.reappearAudExpiryDisabled"
																	[placeholder]="'Reschedule Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
												</ng-container>

												<div class="col mx-1 px-0" *ngIf="audData.exam_status===4">
													<div class="mt-0 mb-2">
														<label class="plannedMonth control-label mb-0">Score</label>
														<div class="gamePlan-Subject-input"
														[ngClass]="audData.exam_status===4 ? 'custom-width-score':''">
														<ng-select [items]="scoreArray" name="audscore"
															[(ngModel)]="audData.score" placeholder="Choose score" class="plannedMonthInput"
															required="required"></ng-select>
													</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>

							</div>
							<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
								<div class="mt-4 d-flex align-content-around align-items-center">
									<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-reg">
										<form name="regForm" #regForm="ngForm" class="mx-auto w-100">
											<div class="game-sub-title"
												style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px;  padding-top: 6px;">
												Taxation & Regulation</div>
											<div style="margin: 5px;" class="md-form">
												<ng-select class="mb-3 w-100 mx-auto"
													[ngClass]="!isMobile?'custom':'custom-mobile'" [items]="statusList"
													name="regstatusList" bindLabel="exam_status_type"
													[(ngModel)]="regData.exam_status" bindValue="exam_status_id"
													placeholder="Choose option" required="required"
													(change)="regChange()"></ng-select>
											</div>

											<div class="mx-0 d-flex flex-fill">
												<div class="col mx-1 px-0"
													*ngIf="regData.exam_status !==2 && regData.exam_status != 5 ">
													<div class="mt-0 mb-2"
														*ngIf="regData.exam_status===1 || regData.exam_status=== 9">
														<label for="regplannercalender"
															class="plannedMonth mb-0">Planned Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="regplannercalender"
																class="bg-white form-control plannedMonthInput"
																name="regdate" [(ngModel)]="regData.date_of_exam"
																(focus)="monthModal.show();switchId=4"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="regData.exam_status===3 || regData.exam_status===6">
														<label class="plannedMonth control-label mb-0">Scheduled Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="regform2"
															name="regmydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="regData.exam_status===4 ? 'custom-width':''"
															[options]="myDatePickerOptions" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="regData.date_of_exam"
															[placeholder]="'Scheduled date'"
															required="required"></mdb-date-picker>
														</div>
															<!-- <label for="ntExpiryDate">Scheduled Date</label> -->
													</div>
													<div class="mt-0 mb-2"
														*ngIf="regData.exam_status===4 || regData.exam_status===7">
														<label class="plannedMonth control-label mb-0">Exam Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="reg2form2"
															name="reg2mydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="regData.exam_status===4 ? 'custom-width':''"
															[options]="passedDateOption" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="regData.date_of_exam"
															[placeholder]="'Exam date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
												</div>
												<ng-container *ngIf="regData.exam_status ===2 || regData.exam_status === 5">
													<div class="col mx-1 px-0">
														<div class="mt-0 mb-2">
															<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
														<div
															class="gamePlan-Subject-input">
															<input type="text" id="barplannercalender"
																class="bg-white form-control plannedMonthInput" name="bardate"
																[(ngModel)]="regData.date_of_exam"
																(focus)="monthModal.show();switchId=4"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">
															<!-- <label for="barplannercalender"
																[ngClass]="regData.date_of_exam?'plannedMonth':''">Planned
																Month</label> -->
														</div>
														</div>
														
													</div>
													<div class="col mx-1 px-0" *ngIf="regData.exam_status === 2">
														<div class="mt-0 mb-2">
															<label class="plannedMonth control-label mb-0">NTS Expiry Date</label>
														<div
															class="gamePlan-Subject-input ntsExpiryDate">
															<!-- <label for="ntExpiryDate">NTS Expiry Date</label> -->
															<mdb-date-picker [outlineInput]="true" id="bar3form3"
																name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="regData.exam_status === 2 ? 'custom-width':''"
																[options]="newDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="regData.expiry_date"
																[disabled]="disableExpiry.regExpiryDisabled"
																[placeholder]="'Expiry Date'"
																required="required"></mdb-date-picker>
														</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="regData.exam_status === 5">
														<div class="mt-0 mb-2">
															<label class="plannedMonth control-label mb-0">Reschedule NTS Expiry</label>
														<div class="gamePlan-Subject-input ntsExpiryDate">
															<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
															<mdb-date-picker [outlineInput]="true" id="bar3form3"
																name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="regData.exam_status === 2 ? 'custom-width':''"
																[options]="newDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="regData.reappear_expiry_date"
																[disabled]="disableExpiry.reappearRegExpiryDisabled"
																[placeholder]="'Expiry Date'"
																required="required"></mdb-date-picker>
														</div>
														</div>
													</div>
												</ng-container>
												<div class="col mx-1 px-0" *ngIf="regData.exam_status===4">
													<div class="mt-0 mb-2">
														<label for="regscore" class="plannedMonth control-label mb-0">Score</label>
													<div class="gamePlan-Subject-input"
														[ngClass]="regData.exam_status===4 ? 'custom-width-score':''">
														<ng-select [items]="scoreArray" name="regscore" class="plannedMonthInput"
															[(ngModel)]="regData.score" placeholder="Choose score"
															required="required"></ng-select>
													</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''">
								<div class="mt-4 d-flex align-content-around align-items-center">
									<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-far">
										<form name="farForm" #farForm="ngForm" class="mx-auto w-100">
											<div class="game-sub-title"
												style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
												Financial Accounting &amp; Reporting</div>
											<div style="margin: 5px;" class="md-form">
												<ng-select class="mb-3 w-100 mx-auto"
													[ngClass]="!isMobile?'custom':'custom-mobile'" [items]="statusList"
													name="farstatusList" bindLabel="exam_status_type"
													[(ngModel)]="farData.exam_status" bindValue="exam_status_id"
													placeholder="Choose option" required="required"
													(change)="farChange()"></ng-select>
											</div>

											<div class="mx-0 d-flex flex-fill">
												<div class="col mx-1 px-0" *ngIf="farData.exam_status != 2 && farData.exam_status != 5">
													<div class="mt-0 mb-2" *ngIf="farData.exam_status===1 || farData.exam_status=== 9">
														<label for="farplannercalender" class="plannedMonth control-label mb-0">Planned Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="farplannercalender"
																class="bg-white form-control plannedMonthInput"
																name="fardate" [(ngModel)]="farData.date_of_exam"
																(focus)="monthModal.show();switchId=3"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="farData.exam_status===3 || farData.exam_status===6">
														<label class="plannedMonth control-label mb-0">Scheduled Date</label>
															<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="farform2"
															name="farmydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="farData.exam_status===4 ? 'custom-width':''"
															[options]="myDatePickerOptions" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="farData.date_of_exam"
															[placeholder]="'Scheduled date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
													<div class="mt-0 mb-2 gamePlan-Subject-input" *ngIf="farData.exam_status===4 || farData.exam_status===7">
														<label class="plannedMonth control-label mb-0">Exam Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="far2form2"
															name="far2mydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="farData.exam_status===4 ? 'custom-width':''"
															[options]="passedDateOption" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="farData.date_of_exam"
															[placeholder]="'Exam date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
												</div>
												<ng-container *ngIf="farData.exam_status ===2 || farData.exam_status === 5">
													<div class="col mx-1 px-0">
														<div class="mt-0 mb-2">
															<label for="farplanner" class="plannedMonth control-label mb-0">Planned Month</label>
															<div class="gamePlan-Subject-input">
																<input type="text" id="farplanner"
																	class="bg-white form-control plannedMonthInput" name="farplan"
																	[(ngModel)]="farData.date_of_exam"
																	(focus)="monthModal.show();switchId=3"
																	required="required" mdbInput="mdbInput" placeholder="Choose month"
																	mdbValidate="mdbValidate">
																<!-- <label for="barplanner"
																	[ngClass]="farData.date_of_exam?'plannedMonth':''">Planned
																	Month</label> -->
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="farData.exam_status === 2">
														<div class="mt-0 mb-2">
															<label class="mb-0 control-label plannedMonth">NTS Expiry Date</label>
															<div
																class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="farExpiry">NTS Expiry Date</label> -->
																<mdb-date-picker [outlineInput]="true" id="farExpiry"
																	name="farExpiry" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="farData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="farData.expiry_date"
																	[placeholder]="'Expiry Date'" required="required"
																	[disabled]="disableExpiry.farExpiryDisabled"></mdb-date-picker>
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="farData.exam_status === 5">
														<div class="mt-0 mb-2">
															<label class="mb-0 control-label plannedMonth">Reschedule NTS Expiry</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="farData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="farData.reappear_expiry_date"
																	[disabled]="disableExpiry.reappearFarExpiryDisabled"
																	[placeholder]="'Reschedule Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
												</ng-container>
												<div class="col mx-1 px-0" *ngIf="farData.exam_status===4">
													<div class="mt-0 mb-2">
														<label for="farScore" class="plannedMonth control-label mb-0">Score</label>
														<div class="gamePlan-Subject-input plannedMonthInput"
														[ngClass]="farData.exam_status===4 ? 'custom-width-score':''">
														<ng-select [items]="scoreArray" name="farscore"
															[(ngModel)]="farData.score" placeholder="Choose score"
															required="required"></ng-select>
													</div>
													</div>
													
												</div>
											</div>
										</form>
									</div>
								</div>

							</div>
							<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''"
								*ngIf="is_forum_admin === 1 || isDisciplineBar === 1">
								<div class="mt-4 d-flex align-content-around align-items-center">
									<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-bar">
										<form name="barForm" #barForm="ngForm" class="mx-auto w-100">
											<div class="game-sub-title"
												style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
												Business Analysis & Reporting</div>
											<div style="margin: 5px;" class="md-form">
												<ng-select class="mb-3 w-100 mx-auto"
													[ngClass]="!isMobile?'custom':'custom-mobile'" [items]="statusList"
													name="becstatusList" bindLabel="exam_status_type"
													[(ngModel)]="barData.exam_status" bindValue="exam_status_id"
													placeholder="Choose option" required="required"
													(change)="barChange()"></ng-select>
											</div>

											<div class="mx-0 d-flex flex-fill">
												<div class="col mx-1 px-0" *ngIf="barData.exam_status !== 2 && barData.exam_status !== 5">
													<div class="mt-0 mb-2"
														*ngIf="barData.exam_status===1 || barData.exam_status=== 9">
														<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="barplannercalender"
																class="bg-white form-control plannedMonthInput"
																name="bardate" [(ngModel)]="barData.date_of_exam"
																(focus)="monthModal.show();switchId=5"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">

														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="barData.exam_status===3 || barData.exam_status===6">
														<label class="plannedMonth control-label mb-0">Scheduled Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="barform2"
															name="barmydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="barData.exam_status===4 ? 'custom-width':''"
															[options]="myDatePickerOptions" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="barData.date_of_exam"
															[placeholder]="'Scheduled date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf=" barData.exam_status===4  || barData.exam_status===7">
														<label class="plannedMonth control-label mb-0">Exam Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="bar2form2"
															name="bar2mydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="barData.exam_status===4 ? 'custom-width':''"
															[options]="barPassedOption" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="barData.date_of_exam"
															[placeholder]="'Exam date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
												</div>
												<ng-container *ngIf="barData.exam_status ===2 || barData.exam_status === 5" >
													<div class="col mx-1 px-0">
														<div class="mt-0 mb-2 ntsExpiryDate">
														<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="barplannercalender"
																class="bg-white form-control plannedMonthInput" name="bardate"
																[(ngModel)]="barData.date_of_exam"
																(focus)="monthModal.show();switchId=5"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">
															<!-- <label for="barplannercalender"
																[ngClass]="barData.date_of_exam?'plannedMonth':''">Planned
																Month</label> -->
														</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="barData.exam_status === 2">
														<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">NTS Expiry Date</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="barData.exam_status === 2 ? 'custom-width':''"
																[options]="newDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="barData.expiry_date"
																[disabled]="disableExpiry.barExpiryDisabled"
																[placeholder]="'Expiry Date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="barData.exam_status === 5">
														<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">Reschedule NTS Expiry</label>
															<div class="mt-0 mb-2 gamePlan-Subject-input">
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="barData.exam_status === 2 ? 'custom-width':''"
																[options]="newDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="barData.reappear_expiry_date"
																[disabled]="disableExpiry.reappearBarExpiryDisabled"
																[placeholder]="'Expiry Date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
															
													</div>
												</ng-container>
												<div class="col mx-1 px-0" *ngIf="barData.exam_status===4">
													<label class="plannedMonth control-label mb-0">Score</label>
													<div class="mt-0 mb-2 gamePlan-Subject-input"
														[ngClass]="barData.exam_status===4 ? 'custom-width-score':''">
														<ng-select [items]="scoreArray" name="barscore" class="plannedMonthInput"
															[(ngModel)]="barData.score" placeholder="Choose score"
															required="required"></ng-select>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>

							</div>
							<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''"
								*ngIf="is_forum_admin === 1 || isDisciplineTcp === 1">
								<div class="mt-4 d-flex align-content-around align-items-center">
									<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-tcp">
										<form name="tcpForm" #tcpForm="ngForm" class="mx-auto w-100">
											<div class="game-sub-title"
												style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px; padding-top: 6px;">
												Tax Compliance & Planning</div>
											<div style="margin: 5px;" class="md-form">
												<ng-select class="mb-3 w-100 mx-auto"
													[ngClass]="!isMobile?'custom':'custom-mobile'" [items]="statusList"
													name="becstatusList" bindLabel="exam_status_type"
													[(ngModel)]="tcpData.exam_status" bindValue="exam_status_id"
													placeholder="Choose option" required="required"
													(change)="tcpChange()"></ng-select>
											</div>

											<div class="mx-0 d-flex flex-fill">
												<div class="col mx-1 px-0" *ngIf="tcpData.exam_status !==2 && tcpData.exam_status !== 5">
													<div class="mt-0 mb-2" *ngIf="tcpData.exam_status===1 || tcpData.exam_status=== 9">
														<label for="tcpplannercalender"
															class="plannedMonth mb-0 control-label">Planned
															Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="tcpplannercalender"
																class="bg-white form-control plannedMonthInput"
																name="tcpdate" [(ngModel)]="tcpData.date_of_exam"
																(focus)="monthModal.show();switchId=6"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="tcpData.exam_status===3 || tcpData.exam_status===6">
														<label class="plannedMonth control-label mb-0">Scheduled Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="tcpform2"
															name="tcpmydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="tcpData.exam_status===4 ? 'custom-width':''"
															[options]="myDatePickerOptions" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="tcpData.date_of_exam"
															[placeholder]="'Scheduled date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf=" tcpData.exam_status===4  || tcpData.exam_status===7">
														<label class="plannedMonth control-label mb-0">Exam Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="tcp2form2"
															name="tcp2mydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="tcpData.exam_status===4 ? 'custom-width':''"
															[options]="passedDateOption" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="tcpData.date_of_exam"
															[placeholder]="'Exam date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
												</div>
												<ng-container *ngIf="tcpData.exam_status ===2 || tcpData.exam_status === 5">
													<div class="col mx-1 px-0">
														<div class="mt-0 mb-2">
															<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<input type="text" id="barplannercalender"
																	class="bg-white form-control plannedMonthInput" name="bardate"
																	[(ngModel)]="tcpData.date_of_exam"
																	(focus)="monthModal.show();switchId=6"
																	required="required" mdbInput="mdbInput" placeholder="Choose month"
																	mdbValidate="mdbValidate">
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="tcpData.exam_status === 2">
														<div class="mt-0 mb-2">
															<label class="plannedMonth control-label mb-0">NTS Expiry Date</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate">NTS Expiry Date</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="tcpData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="tcpData.expiry_date"
																	[disabled]="disableExpiry.tcpExpiryDisabled"
																	[placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
													<div class="col mx-1 px-0" *ngIf="tcpData.exam_status === 5">
														<div class="mt-0 mb-2">
															<label class="plannedMonth control-label mb-0">Reschedule NTS Expiry</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="tcpData.exam_status === 2 ? 'custom-width':''"
																[options]="newDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="tcpData.reappear_expiry_date"
																[disabled]="disableExpiry.reappearTcpExpiryDisabled"
																[placeholder]="'Expiry Date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
													</div>
												</ng-container>
												<div class="col mx-1 px-0" *ngIf="tcpData.exam_status===4">
													<div class="mt-0 mb-2">
														<label for="tcpScore" class="plannedMonth control-label mb-0">Score</label>
														<div class="gamePlan-Subject-input"
														[ngClass]="tcpData.exam_status===4 ? 'custom-width-score':''">
														<ng-select [items]="scoreArray" name="tcpscore" class="plannedMonthInput"
															[(ngModel)]="tcpData.score" placeholder="Choose score"
															required="required"></ng-select>
													</div>
													</div>
													
												</div>
											</div>
										</form>
									</div>
								</div>

							</div>
							<div class="col-12 col-md-12 col-lg-6 mx-auto" [ngClass]="isMobile?'px-0':''"
								*ngIf="is_forum_admin === 1 || isDisciplineIsc === 1">
								<div class="mt-4 d-flex align-content-around align-items-center">
									<div class="d-flex flex-column mx-auto game-plan-block-size subject-block-isc">
										<form name="iscForm" #iscForm="ngForm" class="mx-auto w-100">
											<div class="game-sub-title"
												style="margin: 5px;text-align: center; font-family: var(--open_sans_bold); margin-bottom: 10px; font-size: 16px; color: #ffffff; font-style: normal; line-height: normal; letter-spacing: 0.36px;padding-top: 6px;">
												Information Systems & Control</div>
											<div style="margin: 5px;" class="md-form">
												<ng-select class="mb-3 w-100 mx-auto"
													[ngClass]="!isMobile?'custom':'custom-mobile'" [items]="statusList"
													name="becstatusList" bindLabel="exam_status_type"
													[(ngModel)]="iscData.exam_status" bindValue="exam_status_id"
													placeholder="Choose option" required="required"
													(change)="iscChange()"></ng-select>
											</div>

											<div class="mx-0 d-flex flex-fill">
												<div class="col mx-1 px-0"
													*ngIf="iscData.exam_status !==2 && iscData.exam_status !== 5">
													<div class="mt-0 mb-2"
														*ngIf="iscData.exam_status===1 || iscData.exam_status===9">
														<label for="iscplannercalender"
															class="plannedMonth mb-0 control-label">Planned
															Month</label>
														<div class="gamePlan-Subject-input">
															<input type="text" id="iscplannercalender"
																class="bg-white form-control plannedMonthInput"
																name="iscdate" [(ngModel)]="iscData.date_of_exam"
																(focus)="monthModal.show();switchId=7"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate">
														</div>
													</div>
													<div class="mt-0 mb-2" *ngIf="iscData.exam_status===3 || iscData.exam_status===6">
														<label class="plannedMonth mb-0 control-label">Scheduled Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="iscform2"
															name="iscmydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="iscData.exam_status===4 ? 'custom-width':''"
															[options]="myDatePickerOptions" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="iscData.date_of_exam"
															[placeholder]="'Scheduled date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
													<div class="mt-0 mb-2"
														*ngIf=" iscData.exam_status===4  || iscData.exam_status===7">
														<label class="plannedMonth mb-0 control-label">Exam Date</label>
														<div class="gamePlan-Subject-input">
															<mdb-date-picker [outlineInput]="true" id="isc2form2"
															name="isc2mydate" class="custom-date-picker-input plannedMonthInput"
															[ngClass]="iscData.exam_status===4 ? 'custom-width':''"
															[options]="passedDateOption" mdbValidate="mdbValidate"
															mdbInput="mdbInput" [(ngModel)]="iscData.date_of_exam"
															[placeholder]="'Exam date'"
															required="required"></mdb-date-picker>
														</div>
													</div>
												</div>
												<ng-container *ngIf="iscData.exam_status ===2 || iscData.exam_status === 5">
													<div class="col mx-1 px-0">
														<div class="mt-0 mb-2">
															<label for="barplannercalender" class="plannedMonth mb-0 control-label">Planned Month</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<input type="text" id="barplannercalender"
																class="bg-white form-control plannedMonthInput" name="bardate"
																[(ngModel)]="iscData.date_of_exam"
																(focus)="monthModal.show();switchId=7"
																required="required" mdbInput="mdbInput" placeholder="Choose month"
																mdbValidate="mdbValidate"> 
															</div>
														</div>
													</div>

													<div class="col mx-1 px-0" *ngIf="iscData.exam_status ===2">
														<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">NTS Expiry Date</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
															<!-- <label for="ntExpiryDate">NTS Expiry Date</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																[ngClass]="iscData.exam_status === 2 ? 'custom-width':''"
																[options]="newDatePickerOptions"
																mdbValidate="mdbValidate" mdbInput="mdbInput"
																[(ngModel)]="iscData.expiry_date"
																[disabled]="disableExpiry.iscExpiryDisabled"
																[placeholder]="'Expiry Date'"
																required="required"></mdb-date-picker>
															</div>
														</div>
														
													</div>

													<div class="col mx-1 px-0" *ngIf="iscData.exam_status === 5">
														<div class="mt-0 mb-2">
															<label class="plannedMonth mb-0 control-label">Reschedule NTS Expiry</label>
															<div class="gamePlan-Subject-input ntsExpiryDate">
																<!-- <label for="ntExpiryDate">Reschedule NTS Expiry</label> -->
																<mdb-date-picker [outlineInput]="true" id="bar3form3"
																	name="bar3mydate" class="custom-date-picker-input plannedMonthInput"
																	[ngClass]="iscData.exam_status === 2 ? 'custom-width':''"
																	[options]="newDatePickerOptions"
																	mdbValidate="mdbValidate" mdbInput="mdbInput"
																	[(ngModel)]="iscData.reappear_expiry_date"
																	[disabled]="disableExpiry.reappearIscExpiryDisabled"
																	[placeholder]="'Expiry Date'"
																	required="required"></mdb-date-picker>
															</div>
														</div>
													
														
													</div>
												</ng-container>		
												<div class="col mx-1 px-0" *ngIf="iscData.exam_status===4">
													<label class="plannedMonth mb-0 control-label">Score</label>
													<div class="mt-0 mb-2 gamePlan-Subject-input plannedMonthInput"
														[ngClass]="iscData.exam_status===4 ? 'custom-width-score':''">
														<ng-select [items]="scoreArray" name="iscscore"
															[(ngModel)]="iscData.score" placeholder="Choose score"
															required="required"></ng-select>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
			<!-- <app-eva-confirmation></app-eva-confirmation> -->
		</div>

		<!-- <ng-container *ngIf="showEvaluation"> </ng-container> -->

	</div>
	<div class="modal-footer p-1 bg-white" *ngIf="subjectStatus">
		<button type="button" mdbBtn="mdbBtn" size="md" class="waves-light text-white text-capitalize"
			mdbWavesEffect="mdbWavesEffect" (click)="gpExamValidation()" [disabled]="isButtonDisabled"
			style="background: #0348aa !important; text-transform: none; font-size: 1rem; font-family: var(--open_sans_bold);box-shadow: none;">Confirm
			& Submit</button>
	</div>
</div>
<div mdbModal="mdbModal" #monthModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
	aria-labelledby="mymonthModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-sm" role="document">
		<div class="modal-content">
			<div class="modal-header p-2" style="background: #f7f7f7;">
				<!-- <button type="button" class="close pull-right" aria-label="Close"
                                                                                                                                                    (click)="basicModal.hide()"> <i class="fa fa-times" aria-hidden="true"></i>
                                                                                                                                                    </button> -->
				<button mdbBtn="mdbBtn" type="button" color="light" size="sm" mdbWavesEffect="mdbWavesEffect"
					style="background: #efefef !important; box-shadow: none; padding: 10px 15px; border: 1px solid #f5f2f2;"
					[ngClass]="year>currentYear?'':'disabled'" (click)="preYear()">
					<i class="fas fa-angle-left"></i>
				</button>
				<button mdbBtn="mdbBtn" type="button" color="light" size="sm" mdbWavesEffect="mdbWavesEffect"
					style="background: #efefef !important; box-shadow: none; padding: 10px 15px; border: 1px solid #f5f2f2;">{{year}}</button>
				<button mdbBtn="mdbBtn" type="button" color="light" size="sm" mdbWavesEffect="mdbWavesEffect"
					style="background: #efefef !important; box-shadow: none; padding: 10px 15px; border: 1px solid #f5f2f2;"
					(click)="nextYear()">
					<i class="fas fa-angle-right"></i>
				</button>
			</div>
			<div class="modal-body bg-white">
				<div class="row">
					<div class="col-3" *ngFor="let row of monthService.month;let i=index" style="padding-left: 5px;">
						<button mdbBtn="mdbBtn" type="button" color="light" size="sm" mdbWavesEffect="mdbWavesEffect"
							[ngClass]="year===currentYear && currentMonth>i?'disabled':''"
							(click)="year===currentYear && currentMonth>i?'':setDate(row);monthModal.hide();"
							style="background: #efefef !important; box-shadow: none; padding: 10px 5px; border: 1px solid #f5f2f2; width: 50px;">{{row.month}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>